import * as React from "react";
import { forwardRef } from "react";
const MenuIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "data-category": "actions",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 2,
  y: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 2,
  y: 9,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 2,
  y: 16,
  rx: 1
}));
const ForwardRef = forwardRef(MenuIcon);
ForwardRef.category = "actions";
export { ForwardRef as MenuIcon };